import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../actions/taskActions';
import * as api from '../api/tasks';
import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder'
import { setIslerAdet } from 'src/utils/storage/NavBarAdet'

function* getTasks() {
  try {
    let result = '';
    if (window.navigator.onLine) {
      result = yield call(api.getTasks);
      saveIsler(result.data);
      setIslerAdet(result.data.length);
      yield put(actions.getTasksSuccess(result.data));
    } else {
      result = loadIsler();
      setIslerAdet(result.length);
      yield put(actions.getTasksSuccess(result));
    }
  } catch (error) {
    var resultError = loadIsler();
    setIslerAdet(resultError.length);
    yield put(actions.getTasksSuccess(resultError));
  }
}

function* watchGetTaskRequest() {
  yield takeEvery(actions.Types.GET_TASK_REQUEST, getTasks);
}

const taskSagas = [fork(watchGetTaskRequest)];

export default taskSagas;
